/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const Gender = {
    MALE: 1,
    FEMALE: 2,
    DIVERS: 3
};
